export default {"src":"/_next/static/media/point-circle-fill.52ecf77b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};